import { Injectable } from '@angular/core';
import {BaseDatabaseService} from '../BaseDatabaseService';
import {FioConfig} from '../../../classes/FioConfig';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {formatDate} from '@angular/common';
import {FioLine} from '../../../classes/FioLine';

const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type':  'application/json'
      // 'Authorization': 'my-auth-token'
    }
  )
};

@Injectable({
  providedIn: 'root'
})
export class FioService extends BaseDatabaseService{

  private collectionName = 'fioConfig';

  private static GET_TRANSACTIONS = 'https://us-central1-time4race-6be4a.cloudfunctions.net/transactions';

  constructor(private httpClient: HttpClient) {
    super();
  }

  getAll() {
    return this.db.collection(this.collectionName).get();
  }

  getOne(id) {
    return this.db.collection(this.collectionName).doc(id).get();
  }

  save(id, fioConfig: FioConfig) {
    const config = {token : fioConfig.token,
                profile : fioConfig.profile};
    return this.db.collection(this.collectionName).doc(id).set(config);
  }

  remove(id) {
    return this.db.collection(this.collectionName).doc(id).delete();
  }

  getFioTransaction(token, dateFrom, dateTo) {
    const body = {
      token: token,
      dateFrom: dateFrom,
      dateTo: dateTo
    };
    return this.httpClient.post(FioService.GET_TRANSACTIONS, body, httpOptions).toPromise();
  }

  formatString(date: Date): string {
    return formatDate(date, 'yyyy-MM-dd', 'en-US');
  }

  private checkNull(object){
    return object === null ? {value: ''} : object;
  }

  parseFioData(data): FioLine[] {
    const list: FioLine[] = [];
    data.accountStatement.transactionList.transaction.forEach( t => {
      const fioLine = new FioLine();
      fioLine.id = this.checkNull(t.column22).value;
      fioLine.date = this.checkNull(t.column0).value;
      fioLine.value = this.checkNull(t.column1).value;
      fioLine.currency = this.checkNull(t.column14).value;
      fioLine.from = this.checkNull(t.column10).value;
      fioLine.fromAccount = this.checkNull(t.column2).value;
      fioLine.bankCode = this.checkNull(t.column3).value;
      fioLine.varSym = this.checkNull(t.column5).value;
      fioLine.message = this.checkNull(t.column16).value;

      list.push(fioLine);
    });
    return list;
  }

}
